import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Intro extends React.PureComponent {
    static propTypes = {
        handleMaskHide: PropTypes.func,
    };

    render() {
        const { handleMaskHide } = this.props;

        return (
            <div className={styles.intro}>
                <div id="close" className={styles.close} onClick={handleMaskHide} />
                <div className={styles.title}>国外数据说明</div>
                <div className={styles.content}>
                    <div className={styles.content_p}>
                        <div>1.国外实时数据来源</div>
                        <p>
                            国内权威媒体（如央视新闻、人民日报、环球网等），各国CDC（即疾病控制中心）官网，国外官方媒体。
                        </p>
                    </div>
                    <div className={styles.content_p}>
                        <div>2、统计说明</div>
                        <p>
                            为统计方便，本网将各主权国属地数据单列（例：直布罗陀、法国多个属地），并不代表本网对有关国家、领土、城市或地区的政治或其它所属有任何的假设。
                        </p>
                    </div>
                    <div className={styles.content_p}>
                        <div>3.国外新增病例</div>
                        <p>新增病例统计北京时间一天内各国公布的新增病例总和。</p>
                    </div>

                    <div className={styles.content_p}>
                        <div>4.截止时间</div>
                        <p>页面显示截止时间为标准北京时间。</p>
                    </div>
                    <div className={styles.content_p}>
                        <div>5.人工更新说明</div>
                        <p>
                            自疫情地图更新以来，凤凰新闻坚持使用编辑手动更新原则，从新闻报道中确认每一例数字的真实来源，努力提供最权威、准确、及时的疫情数据。如有任何疑问，欢迎通过凤凰新闻App留言反馈或添加微信ifengnews2018反馈意见。
                        </p>
                    </div>
                </div>
                <div className={styles.mask} />
            </div>
        );
    }
}

export default errorBoundary(Intro);
